
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CirclePaymentReceipt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CirclePaymentReceipt"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"payment_description"},"name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"payment_type"},"name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"payment_created_at"},"name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"payment_status"},"name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"payment_amount"},"name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"payment_transaction_id"},"name":{"kind":"Name","value":"transaction_id"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":238}};
    doc.loc.source = {"body":"fragment CirclePaymentReceipt on CirclePaymentReceipt {\n  payment_description: description\n  payment_type: type\n  payment_created_at: created_at\n  payment_status: status\n  payment_amount: amount\n  payment_transaction_id: transaction_id\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
